"use client";

import styles from "@/styles/modules/components/homepage/moduleFacilities.module.scss";
import { HomepageOptions } from "@/types/wordpress";
import Link from "next/link";
import { useContext, useEffect, useState } from "react";
import { LanguageContext } from "@/context/languageContext";
import Image from "next/image";

interface ModuleFacilitiesProps {
  homepageOptions: HomepageOptions;
}

export default function ModuleFacilities({
  homepageOptions,
}: ModuleFacilitiesProps) {
  const { language } = useContext(LanguageContext);
  const [data, setData] = useState(
    language === "en"
      ? homepageOptions.moduleFacilities
      : homepageOptions.moduleFacilitiesDE
  );

  useEffect(() => {
    setData(
      language === "en"
        ? homepageOptions.moduleFacilities
        : homepageOptions.moduleFacilitiesDE
    );
  }, [
    homepageOptions.moduleFacilities,
    homepageOptions.moduleFacilitiesDE,
    language,
  ]);

  return (
    <section
      className={styles.moduleFacilities}
      style={{
        backgroundColor: data.backgroundColor.backgroundColor || "",
      }}
    >
      <div className={styles.moduleFacilitiesContainer}>
        {data.optionsHomepageModuleFacilities &&
          data.optionsHomepageModuleFacilities.moduleFacilitiesFacilities &&
          data.optionsHomepageModuleFacilities.moduleFacilitiesFacilities
            .slice(0, 2)
            .map((facility, i) => (
              <article key={i}>
                <h3 data-aos="fade-in">{facility.title}</h3>
                {facility.image && (
                  <Link
                    href={facility.link.url || ""}
                    target={facility.link.target}
                    data-aos="fade-in"
                    data-aos-delay="200"
                  >
                    <Image
                      alt={facility.image.node.altText  || "Imperial Riding School"}
                      src={facility.image.node.link}
                      width={facility.image.node.mediaDetails.width}
                      height={facility.image.node.mediaDetails.height}
                      
                    />
                  </Link>
                )}
                {facility.link && (
                  <Link href={facility.link.url} target={facility.link.target} data-aos="fade-in" data-aos-delay="300">
                    {facility.link.title}
                  </Link>
                )}
              </article>
            ))}
      </div>
    </section>
  );
}
